export const CONSUMER_GET_ITEMS = "CONSUMER_GET_ITEMS";

export const CONSUMER_SELECT_ITEM = "CONSUMER_SELECT_ITEM";

export const CONSUMER_GET_ITEM_REPORTS = "CONSUMER_GET_ITEM_REPORTS";

export const CONSUMER_CLEAR_ITEM = "CONSUMER_CLEAR_ITEM";

export const CONSUMER_SELECT_REPORT = "CONSUMER_SELECT_REPORT"
